export const VisibleItems = {
  XS: 1,
  SM: 2,
  MD: 3,
  LG: 4,
  XL: 6,
};

export default null;
